import React from 'react'

import { useGetCustomerInvoices } from '../../../../lib/invoices/hooks/useGetCustomerInvoices'
import Spacer from '../../../Spacer'
import QueryFallback from '../QueryFallback'
import CustomerInvoicesPageContent from './CustomerInvoicesPageContent'

const CustomerInvoicesPage: React.VFC = () => {
  const { data, error, loading, fetchMoreInvoices, refetch } = useGetCustomerInvoices()

  return (
    <>
      {!!error && !loading && (
        <>
          <h3>Invoice History</h3>
          <Spacer size={3} />
          <QueryFallback
            buttonText="Retry Loading Invoices"
            error={error}
            onRetry={() => refetch()}
          />
        </>
      )}
      <CustomerInvoicesPageContent data={data} loading={loading} onLoadMore={fetchMoreInvoices} />
    </>
  )
}

export default CustomerInvoicesPage
